"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[697],{

/***/ 19057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T8": function() { return /* binding */ GetMyVendorProfile; },
/* harmony export */   "XP": function() { return /* binding */ GetPinnedVendorServices2; },
/* harmony export */   "ot": function() { return /* binding */ GetVendorServiceByID; },
/* harmony export */   "w3": function() { return /* binding */ GetVendorServiceBySearch; },
/* harmony export */   "yG": function() { return /* binding */ GetMyVendorBooking; }
/* harmony export */ });
/* unused harmony exports GetVendorServiceRandom, GetVendorServiceByVendor, GetMyVendorsServices, GetPinnedVendorServices */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var urql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26997);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetVendorServiceRandom($page: Int, $pageSize: Int) {\n    getVendorServiceRandom {\n      id\n      interests\n      vendors_id\n      vendor_service_category_id\n      service_name\n      pinned\n      description\n      showcase(page: $page, pageSize: $pageSize) {\n        id\n        vendors_id\n        vendor_service_category_id\n        vendor_service_id\n        media\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetVendorServiceByVendor(\n    $vendorsId: UUID!\n    $page: Int\n    $pageSize: Int\n  ) {\n    getVendorServiceByVendor(vendorsId: $vendorsId) {\n      id\n      interests\n      vendors_id\n      vendor_service_category_id\n      service_name\n      pinned\n      description\n      showcase(page: $page, pageSize: $pageSize) {\n        id\n        vendors_id\n        vendor_service_category_id\n        vendor_service_id\n        media\n      }\n      phone_number\n      email\n      address\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetMyVendorServices($page: Int, $pageSize: Int) {\n    getMyVendorServices {\n      id\n      interests\n      vendors_id\n      vendor_service_category_id\n      service_name\n      price {\n        currency\n        amount\n      }\n      pinned\n      description\n      phone_number\n      email\n      address\n      showcase(page: $page, pageSize: $pageSize) {\n        id\n        vendors_id\n        vendor_service_category_id\n        vendor_service_id\n        name\n        media\n        description\n        tags\n      }\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetPinnedVendorServices($page: Int, $pageSize: Int) {\n    getPinnedVendorServices {\n      id\n      interests\n      vendor_service_category_id\n      vendors_id\n      service_name\n      pinned\n      description\n      category {\n        id\n        Name\n      }\n      showcase(page: $page, pageSize: $pageSize) {\n        id\n        vendors_id\n        vendor_service_category_id\n        vendor_service_id\n        name\n        media\n        description\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetVendorServiceBySearch(\n    $searchTerm: String!\n    $page: Int\n    $pageSize: Int\n  ) {\n    getVendorServiceBySearch(searchTerm: $searchTerm) {\n      id\n      interests\n      vendors_id\n      price {\n        currency\n        amount\n      }\n      rating\n      vendor_service_category_id\n      category {\n        Name\n        id\n      }\n      service_name\n      pinned\n      booked\n      description\n      phone_number\n      email\n      address\n      showcase(page: $page, pageSize: $pageSize) {\n        id\n        vendors_id\n        vendor_service_category_id\n        vendor_service_id\n        media\n      }\n      created_at\n      updated_at\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetMyVendorProfile($page: Int, $pageSize: Int) {\n    getMyVendorProfile {\n      id\n      user_uuid\n      brand_name\n      description\n      logo\n      phone_number\n      email\n      address\n      created_at\n      updated_at\n      services {\n        id\n        interests\n        vendor_service_category_id\n        vendors_id\n        category {\n          Name\n          id\n        }\n        service_name\n        showcase(page: $page, pageSize: $pageSize) {\n          id\n          media\n          vendor_service_id\n          vendor_service_category_id\n          vendors_id\n        }\n        description\n      }\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetVendorServiceByID(\n    $vendorServiceId: UUID!\n    $page: Int\n    $pageSize: Int\n  ) {\n    getVendorServiceByID(vendorServiceId: $vendorServiceId) {\n      id\n      interests\n      vendors_id\n      price {\n        currency\n        amount\n      }\n      vendor_service_category_id\n      category {\n        id\n        Name\n      }\n      service_name\n      pinned\n      description\n      email\n      address\n      showcase(page: $page, pageSize: $pageSize) {\n        id\n        vendors_id\n        vendor_service_category_id\n        vendor_service_id\n        media\n      }\n      phone_number\n      booked\n      rating\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetMyVendorBooking($page: Int, $pageSize: Int) {\n    getMyVendorBooking {\n      vendor_Service {\n        id\n        interests\n        vendors_id\n        price {\n          currency\n          amount\n        }\n        rating\n        vendor_service_category_id\n        category {\n          id\n          Name\n        }\n        service_name\n        pinned\n        booked\n        description\n        phone_number\n        email\n        address\n        showcase(page: $page, pageSize: $pageSize) {\n          id\n          vendors_id\n          vendor_service_category_id\n          vendor_service_id\n          name\n          media\n        }\n      }\n      id\n      user_uuid\n      event_uuid\n      vendors_id\n      vendor_service_id\n      booking_status\n      date\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query GetPinnedVendorServices2($page: Int, $pageSize: Int) {\n    getPinnedVendorServices2 {\n      id\n      name\n      description\n      services {\n        id\n        service_name\n        interests\n        vendors_id\n        price {\n          currency\n          amount\n        }\n        rating\n        category {\n          id\n          Name\n        }\n        pinned\n        booked\n        showcase(page: $page, pageSize: $pageSize) {\n          id\n          vendors_id\n          vendor_service_id\n          vendor_service_category_id\n          media\n        }\n      }\n      images\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}

var GetVendorServiceRandom = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
var GetVendorServiceByVendor = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject1());
var GetMyVendorsServices = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject2());
var GetPinnedVendorServices = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject3());
var GetVendorServiceBySearch = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject4());
var GetMyVendorProfile = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject5());
var GetVendorServiceByID = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject6());
var GetMyVendorBooking = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject7());
var GetPinnedVendorServices2 = (0,urql__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject8());


/***/ }),

/***/ 54473:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hooks_useLockedBody; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useIsomorphicLayoutEffect.tsx

var useIsomorphicLayoutEffect =  true ? react.useLayoutEffect : 0;
/* harmony default export */ var hooks_useIsomorphicLayoutEffect = (useIsomorphicLayoutEffect);

;// CONCATENATED MODULE: ./src/hooks/useLockedBody.tsx

// See: https://usehooks-ts.com/react-hook/use-isomorphic-layout-effect

function useLockedBody() {
    var initialLocked = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var ref = (0,react.useState)(initialLocked), locked = ref[0], setLocked = ref[1];
    // Do the side effect before render
    hooks_useIsomorphicLayoutEffect(function() {
        if (!locked) {
            return;
        }
        // Save initial body style
        var originalOverflow = document.body.style.overflow;
        var originalPaddingRight = document.body.style.paddingRight;
        // Lock body scroll
        document.body.style.overflow = "hidden";
        // Get the scrollBar width
        var root = document.getElementById("___gatsby"); // or root
        var scrollBarWidth = root ? root.offsetWidth - root.scrollWidth : 0;
        // Avoid width reflow
        if (scrollBarWidth) {
            document.body.style.paddingRight = "".concat(scrollBarWidth, "px");
        }
        return function() {
            document.body.style.overflow = originalOverflow;
            if (scrollBarWidth) {
                document.body.style.paddingRight = originalPaddingRight;
            }
        };
    }, [
        locked
    ]);
    // Update state if initialValue changes
    (0,react.useEffect)(function() {
        if (locked !== initialLocked) {
            setLocked(initialLocked);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        initialLocked
    ]);
    return [
        locked,
        setLocked
    ];
}
/* harmony default export */ var hooks_useLockedBody = (useLockedBody);


/***/ }),

/***/ 27643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ store; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js + 1 modules
var esm = __webpack_require__(36902);
// EXTERNAL MODULE: ./src/utils/storage.ts
var storage = __webpack_require__(44920);
;// CONCATENATED MODULE: ./src/store/auth/index.ts

var refreshCookie = (0,storage/* getRefreshCookie */.Qy)();
var accessCookie = (0,storage/* getAccessCookie */.tN)();
var createAuthSlice = function(set) {
    return {
        accessToken: accessCookie ? accessCookie : "",
        setAccessToken: function(arg, ctx) {
            set(function() {
                return {
                    accessToken: arg
                };
            });
            if (ctx) {
                (0,storage/* setAccessCookie */.AA)(arg, ctx);
            } else {
                (0,storage/* setAccessCookie */.AA)(arg);
            }
        },
        refreshToken: refreshCookie ? refreshCookie : "",
        setRefreshToken: function(arg, ctx) {
            set(function() {
                return {
                    refreshToken: arg
                };
            });
            if (ctx) {
                (0,storage/* setRefreshCookie */.gE)(arg, ctx);
            } else {
                (0,storage/* setRefreshCookie */.gE)(arg);
            }
        }
    };
};
/* harmony default export */ var auth = (createAuthSlice);

;// CONCATENATED MODULE: ./src/store/index.ts



// import { immer } from "zustand/middleware/immer";

var useStore = (0,esm/* default */.ZP)()(function() {
    for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++){
        a[_key] = arguments[_key];
    }
    return (0,_object_spread/* default */.Z)({}, auth.apply(void 0, (0,_to_consumable_array/* default */.Z)(a)));
});
// const useStore = create<StoreType>()(
//   immer((...a) => ({
//     ...createAuthSlice(...a),
//   }))
// );
/* harmony default export */ var store = (useStore);


/***/ }),

/***/ 62619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WD": function() { return /* binding */ refreshOnClientError; }
/* harmony export */ });
/* unused harmony exports getAuthClient, addAuthToOperationClient, willAuthErrorClient, didAuthErrorClient, onErrorClient */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var isomorphic_fetch__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94301);
/* harmony import */ var isomorphic_fetch__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(isomorphic_fetch__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _storage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44920);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86501);
/* harmony import */ var jwt_decode__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96245);









var refreshOnClientError = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var errorOut, ref, resultInitial, result, _args = arguments;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    errorOut = _args.length > 0 && _args[0] !== void 0 ? _args[0] : false;
                    ;
                    _ctx.next = 4;
                    return isomorphic_fetch__WEBPACK_IMPORTED_MODULE_1___default()("https://production.inawo.live/query", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            query: "\n							query Refresh($refresh_token: String!) {\n								refresh(refresh_token: $refresh_token) {\n									refresh_token\n									access_token\n									access_expiry\n								}\n							}\n					",
                            variables: {
                                refresh_token: (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .getRefreshCookie */ .Qy)() ? (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .getRefreshCookie */ .Qy)() : ""
                            }
                        })
                    });
                case 4:
                    resultInitial = _ctx.sent;
                    _ctx.next = 7;
                    return resultInitial.json();
                case 7:
                    result = _ctx.sent;
                    if ((ref = result.data) === null || ref === void 0 ? void 0 : ref.refresh) {
                        // save the new tokens in storage for next restart
                        (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .setRefreshCookie */ .gE)(result.data.refresh.refresh_token);
                        (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .setAccessCookie */ .AA)(result.data.refresh.access_token);
                        react_hot_toast__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .ZP.error("Please refresh your browser window.");
                    } else {
                        (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .deleteAccessCookie */ .i)();
                        (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .deleteRefreshCookie */ .V6)();
                        errorOut && react_hot_toast__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .ZP.error("Your session has expired. Please login afresh.");
                    }
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function refreshOnClientError() {
        return _ref.apply(this, arguments);
    };
}();
// still a work in progress, need to find a way to pass in req and res from context
var getAuthClient = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var authState, ref, accessToken, refreshToken, resultInitial, result;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    authState = param.authState;
                    ;
                    if (authState) {
                        _ctx.next = 8;
                        break;
                    }
                    accessToken = (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .getAccessCookie */ .tN)();
                    refreshToken = (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .getRefreshCookie */ .Qy)();
                    if (!accessToken) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", {
                        accessToken: accessToken,
                        refreshToken: refreshToken
                    });
                case 7:
                    return _ctx.abrupt("return", null);
                case 8:
                    _ctx.next = 10;
                    return isomorphic_fetch__WEBPACK_IMPORTED_MODULE_1___default()("https://production.inawo.live/query", {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify({
                            query: "\n										query Refresh($refresh_token: String!) {\n								refresh(refresh_token: $refresh_token) {\n									refresh_token\n									access_token\n									access_expiry\n								}\n							}\n					",
                            variables: {
                                refresh_token: authState.refreshToken
                            }
                        })
                    });
                case 10:
                    resultInitial = _ctx.sent;
                    _ctx.next = 13;
                    return resultInitial.json();
                case 13:
                    result = _ctx.sent;
                    if (!((ref = result.data) === null || ref === void 0 ? void 0 : ref.refresh)) {
                        _ctx.next = 20;
                        break;
                    }
                    // save the new tokens in storage for next restart
                    (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .setRefreshCookie */ .gE)(result.data.refresh.refresh_token);
                    (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .setAccessCookie */ .AA)(result.data.refresh.access_token);
                    return _ctx.abrupt("return", {
                        accessToken: result.data.refresh.access_token,
                        refreshToken: result.data.refresh.refresh_token
                    });
                case 20:
                    // otherwise, if refresh fails, log clear storage and log out
                    console.log("Vendors RefreshQuery Home page Error :>> ", result);
                    (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .deleteAccessCookie */ .i)();
                    (0,_storage__WEBPACK_IMPORTED_MODULE_2__/* .deleteRefreshCookie */ .V6)();
                    // your app logout logic should trigger here
                    react_hot_toast__WEBPACK_IMPORTED_MODULE_3__/* ["default"].error */ .ZP.error("Please refresh your browser window.");
                    return _ctx.abrupt("return", null);
                case 25:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getAuthClient(_) {
        return _ref.apply(this, arguments);
    };
}();
var addAuthToOperationClient = function(param) {
    var authState = param.authState, operation = param.operation;
    // the token isn't in the auth state, return the operation without changes
    if (!authState || !authState.accessToken) {
        return operation;
    }
    // fetchOptions can be a function (See Client API) but you can simplify this based on usage
    var fetchOptions = typeof operation.context.fetchOptions === "function" ? operation.context.fetchOptions() : operation.context.fetchOptions || {};
    return makeOperation(operation.kind, operation, _object_spread_props(_object_spread({}, operation.context), {
        requestPolicy: "network-only",
        fetchOptions: _object_spread_props(_object_spread({}, fetchOptions), {
            headers: _object_spread_props(_object_spread({}, fetchOptions.headers), {
                "x-user-token": authState.accessToken ? "".concat(authState.accessToken) : ""
            })
        })
    }));
};
var willAuthErrorClient = function(param) {
    var authState = param.authState;
    //if there's no authState the trigger the auth arror
    if (!authState) return true;
    // e.g. check for expiration, existence of auth etc
    var accessTokenDecoded = jwt_decode(authState.accessToken);
    var refreshTokenDecoded = jwt_decode(authState.refreshToken);
    // if access token will almost expire
    if (!!(accessTokenDecoded === null || accessTokenDecoded === void 0 ? void 0 : accessTokenDecoded.exp) && Date.now() >= (accessTokenDecoded === null || accessTokenDecoded === void 0 ? void 0 : accessTokenDecoded.exp) * 1000 - 5000) {
        return true;
    }
    // if refresh token will almost expire
    if (!!(refreshTokenDecoded === null || refreshTokenDecoded === void 0 ? void 0 : refreshTokenDecoded.exp) && Date.now() >= (refreshTokenDecoded === null || refreshTokenDecoded === void 0 ? void 0 : refreshTokenDecoded.exp) * 1000 - 5000) {
        return true;
    }
    return false;
};
var didAuthErrorClient = function(param) {
    var error = param.error;
    return error.graphQLErrors.some(function(e) {
        return e.message.includes("unauthenticated");
    });
};
var onErrorClient = function(param, _operation) {
    var graphQLErrors = param.graphQLErrors, networkError = param.networkError;
    if (graphQLErrors) {
        if (graphQLErrors.some(function(param) {
            var message = param.message;
            return message.includes("unauthenticated");
        })) {
            toast.error("Your session has expired.");
        }
    }
    if (networkError) console.log("[Network error]: ".concat(networkError));
};


/***/ })

}]);